<template>
  <div class="flex items-center">
    <vs-avatar :src="params.data.image" class="flex-shrink-0 mr-2" size="30px" @click="$router.push(url)" />
    <router-link :to="url" @click.stop.prevent class="text-inherit hover:text-primary">
      <span>{{ params.data.name }}</span>
      <span>&nbsp;</span>
      <span>{{ params.data.last_name }}</span>
    </router-link>
  </div>
</template>

<script>
    export default {
        name: 'CellRendererLink',
        computed: {
          url() {
            return "/students/"+this.params.data.id
          }
        }
    }
</script>
